import { render, staticRenderFns } from "./dangerJournal.vue?vue&type=template&id=7a8d3cb3"
import script from "./dangerJournal.vue?vue&type=script&lang=js"
export * from "./dangerJournal.vue?vue&type=script&lang=js"
import style0 from "./dangerJournal.vue?vue&type=style&index=0&id=7a8d3cb3&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a8d3cb3')) {
      api.createRecord('7a8d3cb3', component.options)
    } else {
      api.reload('7a8d3cb3', component.options)
    }
    module.hot.accept("./dangerJournal.vue?vue&type=template&id=7a8d3cb3", function () {
      api.rerender('7a8d3cb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/danger/dangerJournal.vue"
export default component.exports